<div class="offer-wizard-details-wrapper">
  <div class="offer-wizard-details-info">
    <div class="offer-wizard-details-name">
      <div
        class="promo-badge"
        *ngIf="badgeOptions && !displayPointsTag"
        [reactComponent]="promoBadgeComponent"
        [props]="badgeOptions"
      ></div>
      <points-tag
        *ngIf="badgeOptions && displayPointsTag"
        [points]="productPromo?.points"
        [multiplier]="productPromo?.multiplier"
      ></points-tag>
      <span>{{ offerName }}</span>
    </div>
    <div class="offer-wizard-details-description">{{ offerDescription }}</div>
    <div *ngIf="minCartPriceText" class="offer-wizard-details-min-cart-price-text ods-typography-body-s-regular">
      {{ minCartPriceText }}
    </div>
    <div *ngIf="maxQuantityText" class="offer-wizard-details-max-quantity-text ods-typography-body-s-regular">
      {{ maxQuantityText }}
    </div>
    <div *ngIf="offerBaseEnvFee > 0" class="offer-wizard-details-env-fee">
      {{ 'the_product_includes_env_fee' | translate }} {{ offerBaseEnvFee | currencyPipe }}
    </div>
  </div>
  <div class="offer-wizard-details-actions">
    <div *ngIf="showPrice" class="offer-wizard-details-price-container">
      <div *ngIf="offerPreOfferPrice" class="offer-wizard-details-starting-price">
        {{ offerPreOfferPrice | currencyPipe }}
      </div>
      <div class="offer-wizard-details-price">{{ offerInstancePrice | currencyPipe }}</div>
    </div>
    <div class="offer-wizard-details-uom-step">{{ stepToUomDescription }}</div>
    <box-quantity
      [subtraction]="offerInstanceQuantity > 1"
      [quantity]="offerInstanceQuantity"
      (add)="onOfferAdd()"
      (remove)="onOfferRemove()"
    ></box-quantity>
  </div>
</div>
